import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { FIREBASE_EVENTS, MODAL_DRAWER_KEY } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { Button } from 'components'
import { setDrawerModal } from 'slices/drawer'
import { CartItems, CartRecommendations } from './components'
import './style.scss'

export function Cart({
  cart,
  categories,
  handleOpenProductDetail,
  handleRemoveFromCart,
  allProducts,
  totalValue,
}) {
  const [availableProducts, setAvailableProducts] = useState([])
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()

  useEffect(() => {
    function isProductNotInCart(product) {
      return !cart.some(item => item.familyName === product.familyName)
    }

    function handleRecommendations() {
      const allProductsOutsideCart = allProducts.filter(isProductNotInCart)
      setAvailableProducts(allProductsOutsideCart)
    }
    handleRecommendations()
  }, [cart, categories, allProducts])

  function handleUpdateProductClick({ id }) {
    const selectedProduct = getProductFromOptionId(id)
    handleOpenProductDetail(selectedProduct)
  }

  function handleRemoveProductClick({ id }) {
    handleRemoveFromCart(id)
  }

  function handleConfirmClick() {
    sendEvent(FIREBASE_EVENTS.SOFTBUNDLE_GO_FOWARD)
    dispatch(
      setDrawerModal({ key: MODAL_DRAWER_KEY.STORE_CONFIRM_PURCHASE, data: { cart, totalValue } })
    )
  }

  function getProductFromOptionId(id) {
    return allProducts.find(product => product.options.some(option => option.id === id))
  }

  return (
    <div className='container-store-cart'>
      <h3 className='title'>Itens no carrinho</h3>
      <CartItems
        cart={cart}
        totalValue={totalValue}
        onUpdateProductClick={handleUpdateProductClick}
        onRemoveProductClick={handleRemoveProductClick}
      />
      <CartRecommendations products={availableProducts} onAddItem={handleOpenProductDetail} />
      <Button
        className='confirm-button'
        disabled={cart.length === 0}
        color='primary'
        size='large'
        onClick={handleConfirmClick}
      >
        Confirmar e seguir
      </Button>
    </div>
  )
}
